export default {
  getEntity: (state) => (entityName, id) => {
    const keys = [
      entityName,
      entityName + "s",
      entityName.toLowerCase(),
      entityName.toLowerCase() + "s"
    ].filter((item, pos, self) => {
      return self.indexOf(item) === pos
    })

    if (keys.every((key) => !state[key]?.data)) return

    const key = keys.find((key) => state[key]?.data[id])

    return state[key]?.data[id]
  },
  getEntities: (state) => (entityName, ids) => {
    const keys = [
      entityName,
      entityName + "s",
      entityName.toLowerCase(),
      entityName.toLowerCase() + "s"
    ].filter((item, pos, self) => {
      return self.indexOf(item) === pos
    })

    function getEntities(entityName, ids) {
      if (!state[entityName]?.data) return []

      if (ids) {
        let arr = ids
        if (typeof ids === "string") {
          arr = state[entityName].pages?.[ids]?.items || []
        }

        return arr.map((id) => {
          if (typeof id !== "string") return id
          return state[entityName].data[id]
        })
      }

      return Object.keys(state[entityName].data).map((id) => {
        return state[entityName].data[id]
      })
    }

    const duplicateSet = new Set()

    return keys
      .map((key) => getEntities(key, ids))
      .flat()
      .filter((e) => e)
      .filter((item) => {
        if (duplicateSet.has(item._id)) return false
        duplicateSet.add(item._id)
        return true
      })
  },
  getMeta: (state) => (entityName, pageName) => {
    return state[entityName]?.[pageName]?.meta || {}
  }
}
